export default __webpack_public_path__ + "static/media/imac.4c0e29ea.svg";